module.exports = __webpack_public_path__ + "media/stable/components/site/scorecard/assets/venue-886ed981c97ba7bf48411069730dd686.svg";